<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()">{{ 'theme.title' | translate }}</a>
  </div>
  <!-- <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
  </nb-select> -->
</div>

<div class="header-container">
  <!-- <nb-select 
    [(selected)]="currentLang" 
    (selectedChange)="switchLanguage($event)" 
    placeholder="语言"
    size="small"
    class="lang-select lang-switcher">
    <nb-option value="vi">🇻🇳 vi</nb-option>
    <nb-option value="cn">🇨🇳 中</nb-option>
  </nb-select> -->
  <label class="login-name">{{ loginName }}</label>

  <nb-actions size="small">
    <nb-action class="user-action" *nbIsGranted="['view', 'user']" >
      <nb-icon icon="log-out-outline" (click)="logout()"></nb-icon>
    </nb-action>
  </nb-actions>
</div>
